<template>
  <section v-if="guide.questions.length" class="geo-guide yaxun-answer-lab wrap" :aria-label="guide.heading || '亚讯数据研判问答'">
    <header><small>{{guide.label || 'YAXUN ANSWER LAB'}}</small><h2>{{guide.heading || '亚讯数据研判问答'}}</h2><p>{{guide.subtitle || '按页面主题提供简短、独立、可核验的分析说明'}}</p></header>
    <div class="geo-guide-grid">
      <article v-for="(item,index) in guide.questions" :key="item[0]"><b>{{String(index+1).padStart(2,'0')}}</b><div><h3>{{item[0]}}</h3><p>{{item[1]}}</p></div></article>
    </div>
  </section>
</template>
<script>
import { seoForPath } from '../../utils/seo'
export default {
  name: 'GeoGuide',
  computed: {
    guide () { return seoForPath(this.$route.path) }
  }
}
</script>
